import { Typography, TypographyProps } from '@healthinal/ui';

export function ModalTitle(props: TypographyProps) {
  return <Typography level="h4" gutterBottom {...props} sx={{ mr: 4, ...props.sx }} />;
}
